module.exports = __webpack_public_path__ + "static/media/mobile_template.e84ffc24.png";